import { render, staticRenderFns } from "./DataTypeIcon.vue?vue&type=template&id=65c63018&scoped=true&"
import script from "./DataTypeIcon.vue?vue&type=script&lang=ts&"
export * from "./DataTypeIcon.vue?vue&type=script&lang=ts&"
import style0 from "./DataTypeIcon.vue?vue&type=style&index=0&id=65c63018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c63018",
  null
  
)

export default component.exports